import React from 'react';

export function FeedbackModal({
  feedback,
  feedbackError,
  feedbackSuccess,
  handleSubmitFeedback,
  closeModal,
  setFeedback
}) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md p-6 rounded-lg shadow-lg">
        <h3 className="text-xl font-semibold mb-4">Your Feedback</h3>
        {feedbackError && (
          <div className="mb-4 text-red-600 text-sm">
            {feedbackError}
          </div>
        )}
        {feedbackSuccess && (
          <div className="mb-4 text-gray-600 text-sm">
            {feedbackSuccess}
          </div>
        )}
        <form onSubmit={handleSubmitFeedback} className="space-y-4">
          <textarea
            className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-gray-400"
            placeholder="Enter your feedback here..."
            rows="4"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            required
          ></textarea>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={closeModal}
              className="px-4 py-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-gray-500 text-white rounded-full hover:bg-gray-600 transition-colors"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
